<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card title="Revue ACOTA">
          <div class="row row-equal">
            <div class="flex md8">
              <va-file-upload
                v-model="sourceFile"
                type="single"
                file-types=".csv"
                dropzone
              />
            </div>
            <div class="flex md4">
              <va-select
                label="Format du fichier de revue"
                v-model="reviewFormat"
                textBy="label"
                :options="reviewFormats"
                no-clear
              />
            </div>
            <div class="flex md12">
              <va-button
                outline
                color="info"
                :disabled="isReviewLoading || !selectedSourceFile"
                @click="generateReviewFile()"
              >
                Générer le fichier de revue
              </va-button>
            </div>
          </div>
        </va-card>
      </div>

      <div class="flex md12">
        <va-card title="Import ACOTA">
          <div class="row row-equal">
            <div class="flex md8">
              <va-file-upload
                v-model="reviewFile"
                type="single"
                file-types=".csv"
                dropzone
              />
            </div>
            <div class="flex md4">
              <div class="acota-summary" v-if="lastImportSummary">
                <div>Revue: {{ lastImportSummary.reviewed }}</div>
                <div>A importer: {{ lastImportSummary.importable }}</div>
                <div>Créés: {{ lastImportSummary.created }}</div>
                <div>Ignorés: {{ lastImportSummary.skipped }}</div>
                <div>Erreurs: {{ lastImportSummary.errors }}</div>
              </div>
            </div>
            <div class="flex md12">
              <va-button
                outline
                color="danger"
                :disabled="isImportLoading || !selectedReviewFile"
                @click="importReviewedFile()"
              >
                Importer le fichier revu
              </va-button>
            </div>
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      sourceFile: [],
      reviewFile: [],
      reviewFormat: {
        id: "xlsx",
        label: "XLSX"
      },
      reviewFormats: [
        {
          id: "xlsx",
          label: "XLSX"
        },
        {
          id: "csv",
          label: "CSV"
        }
      ],
      isReviewLoading: false,
      isImportLoading: false,
      lastImportSummary: null
    };
  },
  computed: {
    selectedSourceFile() {
      return this.getFirstFile(this.sourceFile);
    },
    selectedReviewFile() {
      return this.getFirstFile(this.reviewFile);
    }
  },
  methods: {
    getFirstFile(fileModel) {
      if (!fileModel) {
        return null;
      }

      return Array.isArray(fileModel) ? fileModel[0] : fileModel;
    },
    async generateReviewFile() {
      if (!this.selectedSourceFile) {
        this.launchEpicmaxToast("Sélectionnez un fichier ACOTA CSV");
        return;
      }

      this.isReviewLoading = true;

      try {
        const formData = new FormData();
        formData.append("file", this.selectedSourceFile);
        formData.append("format", this.reviewFormat.id);

        const response = await axios.post("/api/acota/review", formData, {
          responseType: "blob"
        });

        this.downloadBlob(
          response.data,
          this.reviewFormat.id === "csv" ? "acota-review.csv" : "acota-review.xlsx",
          this.reviewFormat.id === "csv"
            ? "text/csv"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );

        this.launchEpicmaxToast("Fichier de revue généré");
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la génération du fichier de revue");
      } finally {
        this.isReviewLoading = false;
      }
    },
    async importReviewedFile() {
      if (!this.selectedReviewFile) {
        this.launchEpicmaxToast("Sélectionnez un fichier de revue CSV");
        return;
      }

      this.isImportLoading = true;

      try {
        const formData = new FormData();
        formData.append("file", this.selectedReviewFile);

        const response = await axios.post("/api/acota/import", formData, {
          responseType: "blob"
        });

        this.lastImportSummary = {
          reviewed: response.headers["x-acota-reviewed-rows"] || 0,
          importable: response.headers["x-acota-importable-rows"] || 0,
          created: response.headers["x-acota-created-rows"] || 0,
          skipped: response.headers["x-acota-skipped-rows"] || 0,
          errors: response.headers["x-acota-error-rows"] || 0
        };

        this.downloadBlob(
          response.data,
          "acota-import-report.csv",
          "text/csv"
        );

        this.launchEpicmaxToast("Import ACOTA terminé");
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l'import ACOTA");
      } finally {
        this.isImportLoading = false;
      }
    },
    downloadBlob(data, fileName, contentType) {
      const blob = new Blob([data], {
        type: contentType
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    }
  }
};
</script>

<style scoped>
.acota-summary {
  font-size: 0.95rem;
  line-height: 1.6;
}
</style>
